var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.22 220.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,223.5A110.11,110.11,0,1,1,223.5,113.38,110.24,110.24,0,0,1,113.39,223.5Zm0-211.87A101.76,101.76,0,1,0,215.15,113.38,101.87,101.87,0,0,0,113.39,11.63Z",
    transform: "translate(-3.28 -3.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,65.77c15.51,0,17.34.06,23.47.34a31.74,31.74,0,0,1,10.78,2,19.23,19.23,0,0,1,11,11,32.34,32.34,0,0,1,2,10.79c.28,6.12.34,8,.34,23.47s-.06,17.34-.34,23.47a32.26,32.26,0,0,1-2,10.78,19.28,19.28,0,0,1-11,11,32.26,32.26,0,0,1-10.78,2c-6.13.28-8,.33-23.47.33S96,161,89.92,160.67a32.34,32.34,0,0,1-10.79-2,19.23,19.23,0,0,1-11-11,31.74,31.74,0,0,1-2-10.78c-.28-6.13-.34-8-.34-23.47s.06-17.35.34-23.47a31.82,31.82,0,0,1,2-10.79,19.18,19.18,0,0,1,11-11,31.82,31.82,0,0,1,10.79-2c6.12-.28,8-.34,23.47-.34m0-10.47c-15.78,0-17.76.07-24,.35a42.72,42.72,0,0,0-14.1,2.7,29.7,29.7,0,0,0-17,17,42.72,42.72,0,0,0-2.7,14.1c-.28,6.19-.35,8.17-.35,24s.07,17.75.35,23.94a42.67,42.67,0,0,0,2.7,14.1,29.7,29.7,0,0,0,17,17,42.47,42.47,0,0,0,14.1,2.7c6.19.28,8.17.35,24,.35s17.75-.07,23.94-.35a42.41,42.41,0,0,0,14.1-2.7,29.7,29.7,0,0,0,17-17,42.41,42.41,0,0,0,2.7-14.1c.28-6.19.35-8.17.35-23.94s-.07-17.76-.35-24a42.47,42.47,0,0,0-2.7-14.1,29.7,29.7,0,0,0-17-17,42.67,42.67,0,0,0-14.1-2.7c-6.19-.28-8.17-.35-23.94-.35",
    transform: "translate(-3.28 -3.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,83.56a29.83,29.83,0,1,0,29.82,29.83,29.82,29.82,0,0,0-29.82-29.83m0,49.19a19.37,19.37,0,1,1,19.36-19.36,19.36,19.36,0,0,1-19.36,19.36",
    transform: "translate(-3.28 -3.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.36,82.38a7,7,0,1,1-7-7,7,7,0,0,1,7,7",
    transform: "translate(-3.28 -3.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta2);
export default __webpack_public_path__ + "static/media/insta2.500a4528846fb9f8fcc31c785259f6f0.svg";
export { ForwardRef as ReactComponent };